module.exports = __webpack_public_path__ + "static/img/bp3.2567a19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911263/bp3.jpg
// module id = L5KW
// module chunks = 1